/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit')
  }
};
console.log('theme.js');
theme.init = function () {
  console.log('LOADED theme.init');
  theme.cacheSelectors();
  theme.mobileNav();
  theme.equalHeights();
  theme.cartPage();
  theme.adjustBuddhaMenu();
  theme.cartDrawer();
  theme.collectionPage();
console.log('theme.init');
  
    theme.productImageGallery();
  

  
    theme.enableAjax();
  
  
  
  function raiseAboveMin(value) {
    if (parseInt(value) <= 0 || value === '') {
      return 1;
    } else {
      return value;
    }
  }
  
  console.log($('.quantity .plus'));

  $('.quantity input').change(function() {
    console.log('CHANGE');
//     console.log(BOLD);
    var text = $(this).val();
    text = text.replace(/(?![0-9])./g, '');
    $(this).val(raiseAboveMin(text));
  });

  $('.quantity .plus').click(function() {
    console.log('PLUS');
    var $input = $(this).parent().parent().find('input');

    var value = parseInt($input.val());
    value++;
    $input.val(value).change();
  });

  $('.quantity .minus').click(function() {
    console.log('MINUS');
    var $input = $(this).parent().parent().find('input');

    var value = parseInt($input.val());
    value--;
    $input.val(raiseAboveMin(value)).change();
  });

  $('.mega-menu-item .mm-submenu').each(function() {
    var height = $(this).outerHeight();
    console.log(height);
    $(this).data('height', height);
  });

  $('.mega-menu-item').mouseenter(function(e) {
    var height = 0;
    $(this).find('.mm-submenu-lv1:first-child .mm-submenu-linklist .mm-submenu-sublist').each(function(sublist) {
      height = Math.max(height, $(this).outerHeight());
    });
    console.log('mega-menu mouseenter', height, $(this).find('.mm-submenu-lv1:first-child .mm-submenu-linklist .mm-submenu-sublist'));
    var defaultHeight = $(this).find('.mm-submenu').data('height');
    $(this).find('.mm-submenu').outerHeight(Math.max(height, defaultHeight));
  });
  
  $('.mm-submenu-lv1').mouseenter(function(e) {
    e.stopPropagation();
    console.log('submenu mouseenter');
    var height = 0;
    $(this).find('.mm-submenu-linklist .mm-submenu-sublist').each(function(sublist) {
      height = Math.max(height, $(this).outerHeight());
      console.log(this, height);
    });
    var defaultHeight = $(this).parent().data('height');
    $(this).parent().outerHeight(Math.max(height, defaultHeight));
  });
  
  $('.mm-submenu-lv1').mouseleave(function(e) {
    console.log('submenu mouseleave');
  });
};

theme.cartDrawer = function() {

  $('.header-bar__module .cart-drawer .update-cart').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    $.ajax({
      type: 'POST',
      data: $(this).closest('form').serialize(),
      url: '/cart/update.js',
      dataType: 'json',
      success: function(cart) {
        
        if (cart.item_count > 0) {
          $('.cart-drawer').removeClass('empty');
        } else {
          $('.cart-drawer').addClass('empty');
        } 
        
//         window.location.reload();
        console.log(cart.total_price);
	    $('.update-cart').hide();
        cart.items.forEach(function(item, index) {
          $cartPrice = $('form').find('.cart-price:eq('+index+')').clone();
          var line_price = parseFloat($('form').find('.cart-price:eq('+index+')').closest('.cart-item').find('.cart-price-per').text().replace('$', ''));
          
          var savings = $cartPrice.find('.savings').text();
          var old_compare_at = parseFloat($cartPrice.find('.cart-item__original-price').text().replace('$', ''))*100;
          $cartPrice.find('.cart-item__original-price').remove();
          $cartPrice.find('.savings').remove();
          var old_price = parseFloat($cartPrice.text().replace('$', ''))*100;
          
          console.log(line_price, item.quantity);
          if (line_price) {
            var new_price_data = line_price * 100 * item.quantity;
            console.log(new_price);
          } else {
            var new_price_data = item.line_price;
          }
          
          console.log(old_price, new_price);
          var ratio = new_price_data/old_price;
          var new_compare_at = ratio * old_compare_at;
          
          var new_price = '<small class="cart-item__original-price"><s>$'+(Math.floor(new_compare_at)/100).toFixed(2)+'</s></small>';
          new_price += '$'+((new_price_data/100).toFixed(2));
//           new_price += '<span class="savings">'+savings+'</span>';
          
          $('.header-bar__module .cart-drawer .cart-price:eq('+index+')').html(new_price);
        });
        $('.cart-drawer .total-container span:last-child').text('$'+(cart.total_price/100).toFixed(2));
      }
    });
  });
  
  $('.ajax.cart__remove').click(function(e) {
    e.preventDefault();
    var updates = {}
    var id = $(this).closest('.cart-item').data('id');
    console.log(id);
    updates[id] = 0;
    
    $.ajax({
      type: 'POST',
      data: {updates: updates},
      url: '/cart/update.js',
      dataType: 'json',
      success: function(cart) {
        console.log(cart);
        
        $('.header-bar__module .cart-drawer .cart-item[data-id="'+id+'"]').remove();
        $('.cart-drawer .total-container span:last-child').text('$'+(cart.total_price/100));
      }
    });
  });
  
//   $('.ajax.update-cart').click(function(e) {
//     e.preventDefault();
    
//     var updates = [];
    
//     $('.cart-drawer .cart__quantity-selector').each(function() {
//       updates.push($(this).val());
//     });
    
//     $.ajax({
//       url: '/cart/update.js',
//       updates: updates
//     });
//   });
  
  $('.cart-drawer, .cart-wrapper').on('change', '.cart__quantity-selector', function() {
    $(this).parent().next().show();
  });
  
//   BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
  
}

$('.cart-page-link').click(function(e) {
  if ($(window).width() < 1280) {
    e.preventDefault();
    e.stopPropagation();
    
    $('body').toggleClass('menu_open');
    
    $('.mobile-search').removeClass('active');
    $('.mobile-menu-item.icon-search').removeClass('open');
    $('.mobile-menu-item.cart-page-link').addClass('open');
    $('.mobile-menu-item.icon-menu').removeClass('open');
    
    $('.cart-drawer').addClass('active');
    //window.location.href = '/cart';
  }
});

theme.adjustBuddhaMenu = function() {
  var count = 0;
  function checkForBuddhaMenu() {
    
    if ($('.buddha-menu-item').length > 0) {
      $('.buddha-menu-item .mm-image-container').closest('li').addClass('containsImage');
      console.log($('.buddha-menu-item .mm-image-container').closest('li'));
    } else {
      console.log(count);
      count++
      setTimeout(checkForBuddhaMenu, 4000);
    }
  }
  
  checkForBuddhaMenu();
}

$(window).scroll(function() {
  if ($(window).scrollTop() > 124) {
    $('body').addClass('scrolledDown').removeClass('atTop');
  } else {
    $('body').removeClass('scrolledDown').addClass('atTop');  
  }
});
$(window).scroll();

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
  
  $('#mobile-menu .mobile-menu-item.icon-menu').off('click');
  $('#mobile-menu .mobile-menu-item.cart-page-link').off('click');
  
  $('.cart-link-container').click(function(e) {
    e.preventDefault();
  });
  
  $('#mobile-menu .mobile-menu-item.icon-menu').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.cart-drawer').removeClass('active');
    $('.mobile-search').removeClass('active');
    
    $('#mobile-menu .mobile-menu-item.icon-search').removeClass('open');
    $('#mobile-menu .mobile-menu-item.cart-page-link').removeClass('open');
    $(this).toggleClass('open');
    
    if ($('.mobile-menu-expand').hasClass('open')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
    $('.mobile-menu-expand').toggleClass('open');
    $(".olark-launch-button").removeClass('open');
  });
  
  $('#mobile-menu .mobile-menu-item.icon-search').click(function(e) {
    e.stopPropagation();
    $('body').removeClass('menu_open');
    $('#mobile-menu .mobile-menu-item.icon-menu').removeClass('open');
    $('#mobile-menu .mobile-menu-item.cart-page-link').removeClass('open');
    $(this).toggleClass('open');
    $('.mobile-menu-expand').removeClass('open');
    $('.cart-drawer').removeClass('active');
    
    $('.mobile-search').toggleClass('active');
    $(".olark-launch-button").toggleClass('open');
  });
  
  $('#mobile-menu .mobile-menu-item.cart-page-link').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#mobile-menu .mobile-menu-item.icon-menu').removeClass('open');
    $('#mobile-menu .mobile-menu-item.icon-search').removeClass('open');
    $(this).toggleClass('open');
    $('.mobile-menu-expand').removeClass('open');
    $('.mobile-search').removeClass('active');
    
    if ($('.cart-drawer').hasClass('active')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
    $('.cart-drawer').toggleClass('active');
    $(".olark-launch-button").removeClass('open');
  });
  
  $('.tablet-search').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    $('.mobile-menu-item.icon-search').addClass('open');
    $('.mobile-menu-item.cart-page-link').removeClass('open');
    $('.mobile-menu-item.icon-menu').removeClass('open');
    $('body').toggleClass('mobile-search-active');
    $('html,body').css("overflow",'hidden');
    $('.mobile-search').toggleClass('active');
  });
  
  $(document).click(function(e) {
    if ($('.mobile-menu-expand').hasClass('open') || $('#mobile-menu .mobile-menu-item.icon-menu').hasClass('open') || $('.cart-drawer').hasClass('active') ) {
      e.preventDefault();
    }
    
    $('body').removeClass('menu_open');
    $('.mobile-menu-expand').removeClass('open');
    $('body').removeClass('mobile-search-active');
    $('.mobile-menu-item.icon-search').removeClass('open');
    $('.mobile-menu-item.cart-page-link').removeClass('open');
    $('.mobile-menu-item.icon-menu').removeClass('open');
    $('.cart-drawer').removeClass('active');
    $('.mobile-search').removeClass('active');
    
    $('html, body').removeClass('flypanels-open');
    $('.flypanels-container').removeClass('openleft');
  });
  
  // $('#mobile-flypanel').click(function(e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   $('body').toggleClass('menu_open');
  //   $('html, body').toggleClass('flypanels-open');
  //   $('.flypanels-container').toggleClass('openleft');
    
  //   $(this).toggleClass('open');
  //   $('.mobile-search').removeClass('active');
  //   $('.mobile-menu-item.icon-search').removeClass('open');
  //   $('.mobile-menu-item.cart-page-link').removeClass('open');
  //   $('.mobile-menu-item.icon-menu').addClass('open');
  //   $('.mobile-menu-expand').toggleClass('open');
  // });

  $('#mobile-flypanel').off('click').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      $('body').toggleClass('menu_open');
      $('html, body').toggleClass('flypanels-open');
      $('.flypanels-container').toggleClass('openleft');
      
      $(this).toggleClass('open');
      $('.mobile-search').removeClass('active');
      $('.mobile-menu-item.icon-search').removeClass('open');
      $('.mobile-menu-item.cart-page-link').removeClass('open');
      $('.mobile-menu-item.icon-menu').addClass('open');
      $('.mobile-menu-expand').toggleClass('open');
  });
  
  $('.mobile-menu-expand .overlay').click(function(e) {
    e.stopPropagation();
    
    $('body').removeClass('menu_open');
    $('html, body').removeClass('flypanels-open');
    $('.flypanels-container').removeClass('openleft');
    
    $('.mobile-menu-item').removeClass('open');
    $('.mobile-menu-expand').removeClass('open');
  });

  $('.cart-drawer .overlay').click(function() {
    $('.cart-drawer').removeClass('active');
    $('.mobile-menu-item').removeClass('open');
    $('body').removeClass('menu_open');
  });
  
  $('.mobile-search .overlay').click(function() {
    $('.mobile-search').removeClass('active');
    $('.mobile-menu-item').removeClass('open');
    $(".olark-launch-button").removeClass('open');
  });
  
  $(document).on('click','body *,#mobile-menu',function(){
    console.log("123");
    if($(this).hasClass("search-overlay")){
      $('.mobile-search').removeClass('active');
      $('.mobile-menu-item').removeClass('open');
      $(".olark-launch-button").removeClass('open');
      $('body').toggleClass('mobile-search-active');
      $('html,body').css("overflow",'scroll');
      $('.mobile-search').toggleClass('active');
    }
  });
  
  $('.cart-drawer, .mobile-menu-expand, .mobile-search').click(function(e) {
    e.stopPropagation();
  });
  
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  
    return;
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
  
//   BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
  
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";

  // Make a copy of the add to cart button should we flip it
//   $addToCartBtn
//     .clone(true)
//     .prop('disabled', false)
//     .removeClass('disabled')
//     .addClass('btn--unflipped')
//     .find('span')
//     .text(addToCartText)
//     .end()
//     .hide()
//     .insertAfter($addToCartBtn);

  $addToCartBtn
//     .unbind('click')
    .removeClass('disabled')
    .find('span')
    /*.text("View cart")*/
  	.text("Added")
    .end()
//     .bind('click', function(e) {
//       e.preventDefault();
//       window.location.href = '/cart';
//     })
    .prop('disabled', false)
    .addClass('btn--flipped green')
    .after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></span>');

    setTimeout(function() {
      $addToCartBtn
        .html('<span id="AddToCartText">Add</span>')
        .removeClass('btn--flipped green');
    }, 2000);
           
  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

theme.enableAjax = function () {
  
  console.log('enableAjax', theme.cache.$addToCartBtn[0]);
  var closeCartDrawerTimer;
  
  function closeCartDrawer() {
    $('.cart-drawer').css('pointer-events', 'none').fadeOut(750, function() {
       setTimeout(function() {
        $('.cart-drawer').removeAttr('style').removeClass('open');
      }, 1000);
    });
  }
  
  console.log('before');
  if (window.location.href.indexOf('show_minicart=true') > 0) {
    console.log('within');
    $('.cart-drawer').addClass('open');
    closeCartDrawerTimer = setTimeout(closeCartDrawer, 3000);
  }
  console.log('after');
  
  theme.cache.$addToCartBtn.bind('click', function(e) {
    e.preventDefault();
    console.log('source!');
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
        if ($addToCartForm.find('.subscribe-savings').length > 0) {
          var discounted_price = parseFloat($addToCartForm.find('.subscribe-savings').text().match(/^\s*\$[0-9]+.[0-9]{2}/)[0].replace('$', ''));
        }
    console.log($addToCartForm.serialize());
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          
          console.log('fff');
          var url = window.location.href;
          if (url.indexOf('show_minicart=true') === -1) {
            if (url.indexOf('?') > -1) {
               url += '&show_minicart=true'
            } else {
               url += '?show_minicart=true'
            }
          }
          window.location.href = url;
          
          var compare_at_price = (parseFloat($addToCartBtn.closest('form').find('.tabin-msp span').text().replace('$', ''))*100)*lineItem.quantity;
          
          console.log(lineItem);
          
          $('.cart-drawer').removeClass('empty');
          function originalSuccess() {
            if ($('.header-bar__module .cart-item[data-id="'+lineItem.id+'"]').length) {
              $('.header-bar__module .cart-item[data-id="'+lineItem.id+'"] .cart__quantity-selector').val(lineItem.quantity);
          
              var new_line = '<small class="cart-item__original-price"><s>'+Shopify.formatMoney(compare_at_price).replace('$ ', '$')+'</s></small>';
              new_line += Shopify.formatMoney(lineItem.line_price).replace('$ ', '$');
              new_line += '<span class="savings">Save '+Math.floor(((compare_at_price - lineItem.line_price)/compare_at_price)*100)+'%</span>';
              
              $('.header-bar__module .cart-item[data-id="'+lineItem.id+'"] .cart-price').html(new_line);
            } else {
//               var new_line = '<div class="cart-item" data-id="'+lineItem.id+'">';
//               new_line += '<div class="cart-image"><img src="'+lineItem.image+'"></div>';
//               new_line += '<div class="cart-info">';
//               new_line += '<a href="'+lineItem.url+'">'+lineItem.title+'</a>';
//               new_line += '<span>Qty: <input type="number" class="cart__quantity-selector" name="updates[]" id="updates_25900009603" value="'+lineItem.quantity+'" min="0"></span>';
//               new_line += '</div>';
//               new_line += '<div class="cart-price">'+Shopify.formatMoney(lineItem.price).replace('$ ', '$')+'</div>';
//               new_line += '</div>';
              
              var new_line = '<div class="cart-item" data-id="'+lineItem.id+'">';
              new_line += '<div class="cart-image">';
              new_line += '<img src="'+lineItem.image+'">';
              new_line += '<a href="/cart/change?line=0&amp;quantity=0" class="bold-ro-remove ajax cart__remove ">';
              new_line += '<small>remove</small>';
              new_line += '</a>';
              new_line += '</div>';
              new_line += '<div class="cart-info">';
              new_line += '<a href="'+lineItem.url+'">'+lineItem.product_title+'</a>';
              new_line += '<a href="'+lineItem.url+'">'+lineItem.title.replace(lineItem.product_title, '').replace('-', '')+'</a>';
              
              new_line += '<div class="bold-info">';
              new_line += '<div class="bold_recurring_desc">';
              if (lineItem.properties && lineItem.properties.frequency_num) {
                new_line += '<span class="bold_ro_every">Deliver every</span>';
                new_line += '<span class="bold_ro_frequency_num">'+lineItem.properties.frequency_num+'</span>';
                new_line += '<span class="bold_ro_frequency_type_text">'+lineItem.properties.frequency_type_text+'</span>';
              }
              new_line += '</div>';
              new_line += '</div>';
              
              new_line += '</div>';
              
              if (lineItem.properties && lineItem.properties.frequency_num) {
                new_line += '<div class="cart-price-per">$'+discounted_price+'/per</div>';
              } else {
                new_line += '<div class="cart-price-per">'+Shopify.formatMoney(lineItem.price)+'/per</div>';
              }
              
              new_line += '<div class="cart-qty">';
              new_line += '<div class="cart-quantity-button quantity">';
              new_line += '<input type="text" class="cart__quantity-selector" name="updates[]" id="updates_'+lineItem.id+'" value="'+lineItem.quantity+'" min="0">';
              new_line += '<div class="quantity-buttons">';
              new_line += '<span class="plus">+</span>';
              new_line += '<span class="minus">-</span>';
              new_line += '</div>';
              new_line += '</div>';
              new_line += '<input type="submit" name="update" class="btn--secondary ajax update-cart" value="Update">';
              new_line += '</div>';
              new_line += '<div class="cart-price">';
              if (lineItem.properties && lineItem.properties.frequency_num) {
              new_line += '<small class="cart-item__original-price"><s>'+Shopify.formatMoney(compare_at_price).replace('$ ', '$')+'</s></small>';
              new_line += '$' + discounted_price;
              } else {
              new_line += '<small class="cart-item__original-price"><s>'+Shopify.formatMoney(compare_at_price).replace('$ ', '$')+'</s></small>';
              new_line += Shopify.formatMoney(lineItem.line_price).replace('$ ', '$');
//               new_line += '<span class="savings">Save '+Math.floor(((compare_at_price - lineItem.line_price)/compare_at_price)*100)+'%</span>';
              }
              new_line += '</div>';
              new_line += '</div>';
              
              var $new_line = $(new_line);
              
              function raiseAboveMin(value) {
                if (parseInt(value) <= 0 || value === '') {
                  return 1;
                } else {
                  return value;
                }
              }
              
              $new_line.find('.quantity input').change(function() {
                console.log('CHANGE');
//                 console.log(BOLD);
                var text = $(this).val();
                text = text.replace(/(?![0-9])./g, '');
                $(this).val(raiseAboveMin(text)); // qw12
              });

              $new_line.find('.quantity .plus').click(function() {
                console.log('PLUS');
                var $input = $(this).parent().parent().find('input');

                var value = parseInt($input.val());
                value++;
                $input.val(value).change();
              });

              $new_line.find('.quantity .minus').click(function() {
                console.log('MINUS');
                var $input = $(this).parent().parent().find('input');

                var value = parseInt($input.val());
                value--;
                $input.val(raiseAboveMin(value)).change();
              });
              
              $('.cart-drawer form > p').remove();
              $('.cart-drawer .cart-footer').show();
              $('.cart-drawer form').prepend($new_line);
              
              $('.header-bar__module .cart-item .cart__remove').each(function(index) {
                console.log(index);
              });
            }
            
            $('.cart-drawer').addClass('open');
            closeCartDrawerTimer = setTimeout(closeCartDrawer, 3000);
                        
            $.getJSON('/cart.js', function(cart) {
              theme.cache.$cartCount.text(cart.item_count);
              $('.cart-drawer .total-container span:last-child').text('$'+(cart.total_price/100));
              $('.hidden-count').removeClass('hidden-count');
            });
            $addToCartBtn.removeClass('btn--loading');
            theme.addToCartflip($addToCartBtn);
          
          }
          
          if (typeof(upsell_main) === "function") {
            upsell_main();
          }
          if (typeof(upsell_offer) === "function") { 
            upsell_offer();
            jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
//               originalSuccess();
            });
          } else { 
//             originalSuccess();
          }
          
          
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
  
  $('.cart-drawer .fa-close').click(closeCartDrawer);
  
  $('.cart-drawer').mouseover(function() {
    if (closeCartDrawerTimer) {
      clearTimeout(closeCartDrawerTimer);
    }
  });
  
  $('.cart-drawer').mouseleave(function() {
    if ($(this).hasClass('open')) {
      closeCartDrawer();
    }
  });
  
  $('.mobile-cart-page-link').click(function(e) {
    e.preventDefault();
    $('.cart-drawer').toggleClass('open');
  });
};

theme.collectionPage = function () {
  $('.sidebar-items').scroll(function(e) {
    if($(this).scrollTop() === 0) {
      $(this).parent().removeClass('top-shadow');
    } else {
      $(this).parent().addClass('top-shadow');
    }
    
    if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
      $(this).parent().removeClass('bottom-shadow');
    } else {
      $(this).parent().addClass('bottom-shadow');
    }
  });
  
  $('.items-container').scroll(function(e) {
    if($(this).scrollTop() === 0) {
      $(this).parent().removeClass('top-shadow');
    } else {
      $(this).parent().addClass('top-shadow');
    }
    
    if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 1) {
      $(this).parent().removeClass('bottom-shadow');
    } else {
      $(this).parent().addClass('bottom-shadow');
    }
  });
}

// Initialize theme's JS on docready
$(theme.init)
